import { getTranslate } from '@/helpers/translateHelpers';
import { EStatus, TDictionary, TDropDownItemWithType } from '@/types';

export const getStatusInit = (): TDictionary<TDropDownItemWithType<string>> => {
  return {
    active: {
      label: getTranslate('body.topBar.status.active'),
      value: EStatus.ACTIVE,
    },
    draft: {
      label: getTranslate('body.topBar.status.draft'),
      value: EStatus.DRAFT,
    },
  };
};
